import { Component, OnInit, ViewChild, Input, Output, HostListener, TemplateRef, ElementRef, EventEmitter } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';
import * as moment from 'moment';
import * as $$ from 'jquery';
import { element } from 'protractor';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PipeTransform, Pipe } from '@angular/core';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-stock-bac',
    templateUrl: './stock-bac.component.html',
    styleUrls: ['./stock-bac.component.css']
})

export class StockBacComponent implements OnInit {
    @Input() depuisDemande: Boolean;

    @Output() closefct = new EventEmitter<any>();
    @ViewChild('template') template;
    modalRef: BsModalRef;
    config = {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: false,
        class: 'confirmModal'
    };

    showBon: Boolean = false;
    emptyTitle: String = 'Recherchez un client';
    emptyDetail: String = 'Pour afficher tous les bons d\'un client vous pouvez saisir directement le nom du client ou le code client';
    rows = [];

    temp: any[] = [];
    listeFiltre: any[] = [];
    filter: String = '';
    searchCritere: String = '';
    checkedall: Boolean = false;
    showFicheclt: Boolean = false;
    addBon: Boolean = false;

    public status: { isopen: boolean, child: boolean } = { isopen: false, child: false };
    filterbon: any[] = [];

    idFournisseurSearch = 0;
    idArticleSearch = 0;
    idTypeContenantSearch = 0;

    showPopover: Boolean = false;
    editTypeContenant: Boolean = false;
    detailBon;
    timeout;

    // Filtres
    public proprietes: {
        parFournisseur: boolean,
        parTypeDeContenant: boolean,
        parFlux: boolean
    };
    public etats = [];
    public etatsSelected = [];

    btnAffichage: String = 'normal';
    searchTable = ['fournisseurs', 'articleStockBenne', 'typeContenantStockBenne'];
    client = {};
    heigth: Number = 30;
    heigthClt: Number = 0;
    public loadingIndicator: Boolean = false;
    dynamicFiltre: any[] = [];
    selected = [];
    typebon: any[] = [];
    // paramSociete = [];
    default = 0;
    nbdigit;
    error: String = '';
    isAll: Boolean = false;
    rowCount = 0;
    type = 26;
    selectedFilter: any = {};
    rowSelect: any = {};

    @ViewChild('msg') msg;
    @ViewChild('myTable') table: any;

    constructor(public common: CommonService, private modalService: BsModalService, private el: ElementRef) { }

    ngOnInit() {
        this.emptyDetail = 'Pour afficher tous les pro forma d\'un client vous pouvez saisir directement le nom du client ou le code client';

        this.proprietes = {
            parFournisseur: true, // this.common.userDetail['filtreFournisseur'] ? true : false,
            parTypeDeContenant: true, // this.common.userDetail['filtreTypeC'] ? true : false,
            parFlux: true, // this.common.userDetail['filtreArticle'] ? true : false,
        };

        this.getListeEtatBac().then(datas => {
            const listeEtatBac = datas.data;
            this.etats.push({ id: 0, libelle: 'Non renseigné', libelleObjetEntite: 'Non renseigné', selected: true });
            listeEtatBac.forEach(etatBac => {
                this.common.userDetail = this.common.userDetail || {};
                this.common.userDetail['filtreStockBac'] = this.common.userDetail['filtreStockBac'] || [];
                this.common.userDetail['filtreStockBac'].forEach(f => {
                    if (f.etatBac && etatBac.id === f.etatBac.id) {
                        this.etats.push({ id: 0, libelle: etatBac.libelleObjetEntite, libelleObjetEntite: etatBac.libelleObjetEntite, selected: true /* f.selected */ });
                    }
                });
            });

            this.load();
        });
    }

    filterItemSelected(item) {
        return item.selected;
    }

    addFiltre(event) {
        this.selected = [];
        this.checkedall = false;
        let isFournisseurSearch = false;
        let isArticleSearch = false;
        let isTypeContenantSearch = false;

        this.listeFiltre = event;
        if (event.length) {
            this.showBon = true;
            event.forEach(elt => {
                if (elt.table === 'fournisseurs') {
                    isFournisseurSearch = true;
                    this.idFournisseurSearch = elt.id;
                }
                if (elt.table === 'articleStockBenne') {
                    isArticleSearch = true;
                    this.idArticleSearch = elt.id;
                }
                if (elt.table === 'typeContenantStockBenne') {
                    isTypeContenantSearch = true;
                    this.idTypeContenantSearch = elt.id;
                }
                if (elt.table === 'all') {
                    this.isAll = true;
                }

                this.load();
            });

            if (isFournisseurSearch || isArticleSearch || isTypeContenantSearch) {

            } else {

            }
        } else {
            this.rows = [];
            this.idFournisseurSearch = 0;
            this.idArticleSearch = 0;
            this.idTypeContenantSearch = 0;
            this.dynamicFiltre = [];
            this.load();
        }
    }

    public toggleDropdown($event: MouseEvent): void {
        $event.preventDefault();
        $event.stopPropagation();
        this.status.isopen = !this.status.isopen;
    }

    public change(value: boolean): void {
        this.status.isopen = value;
    }

    selectAffichage(elt) {
        this.btnAffichage = elt;
        this.common.defaultViewEcofact['gestionBons'].affichage = elt;

        if (this.table) {
            this.table.element.className = 'material ngx-datatable fixed-header selectable checkbox-selection ' + elt;
            switch (elt) {
                case 'normal':
                    this.heigth = 30;
                    break;
                case 'min':
                    this.heigth = 50;
                    break;
                case 'max':
                    this.heigth = 20;
                    break;
            }
        }
    }

    onActivate(event) {
    }

    mouseLeave(event) {
        this.showPopover = false;
        clearTimeout(this.timeout);
        $('.popover').popover('hide');
    }

    getRowClass(row) {
        return {
            'selected-row': row.isChecked === true
        };
    }

    load(event?) {
        this.etatsSelected = [];
        let i = 0;
        this.etats.forEach(elt => {
            if (elt.selected) {
                elt['arrayIndex'] = i;
                this.etatsSelected.push(elt);
            }

            i++;
        });

        this.loadListe();
    }

    loadListe() {
        this.getListeBacStock();
    }

    arrayUnique(array) {
        const a = array.concat();
        for (let i = 0; i < a.length; ++i) {
            for (let j = i + 1; j < a.length; ++j) {
                if (a[i] === a[j]) {
                    a.splice(j--, 1);
                }
            }
        }
        return a;
    }

    deleteFilter(index, elt) {
        this.filterbon.splice(index, 1);
        this.idFournisseurSearch = 0;
        this.idArticleSearch = 0;
        this.idTypeContenantSearch = 0;
        this.loadListe();
    }

    checkedRow(selected) {
        if (selected.isChecked) {
            this.selected.push(selected);
        } else {
            this.selected.splice(this.selected.indexOf(selected), 1);
        }
    }

    returnListChoix() {
        return this.common.filtreProforma;
    }

    getListeBacStock() {
        this.loadingIndicator = true;
        const param = {
            'servlet': 'DBGestionBacStock',
            'module': 'Ecobac',
            'type': 'map',
            'compression': 'true',
            'data': {
                'OPERATION': {
                    'typeParam': 'int',
                    'valeur': 1
                },
                'FILTRE_FOURNISSEUR': {
                    'typeParam': 'boolean',
                    'valeur': this.proprietes.parFournisseur
                },
                'FILTRE_TYPECONTENANT': {
                    'typeParam': 'boolean',
                    'valeur': this.proprietes.parTypeDeContenant
                },
                'FILTRE_FLUX': {
                    'typeParam': 'boolean',
                    'valeur': this.proprietes.parFlux
                },
                'CLEF_FOURNISSEUR': {
                    'typeParam': 'int',
                    'valeur': this.idFournisseurSearch
                },
                'CLEF_TYPE_CONTENANT': {
                    'typeParam': 'int',
                    'valeur': this.idTypeContenantSearch
                },
                'CLEF_ARTICLE': {
                    'typeParam': 'int',
                    'valeur': this.idArticleSearch
                },
            }
        };

        return this.common.post('', { param: param }).then(datas => {
            this.loadingIndicator = false;
            this.showBon = true;
            this.rows = datas.data || [];
            this.rows.forEach(row => {
                row.fournisseurToString = (row.fournisseur && row.fournisseur.nom) ? row.fournisseur.nom : 'Non renseigné';
                row.typeContenantToString = (row.typeContenant && row.typeContenant.famille ? (row.typeContenant.famille.libelle + ' ') : '') +
                    (row.typeContenant && row.typeContenant.cubage && row.typeContenant.cubage.cubage ? row.typeContenant.cubage.cubage : '');
                if (!row.typeContenantToString) {
                    row.typeContenantToString = 'Non renseigné';
                }
                row.articleToString = row.art ? (row.art.libelle ? row.art.libelle : row.art.libelleObjetEntite) : 'Non renseigné';
            });
        });
    }

    getListeEtatBac() {
        const param = {
            'servlet': 'DBGestionObjetEntite',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                    'typeParam': 'int',
                    'valeur': 4
                }
            }
        };

        return this.common.post('', { param: param });
    }

    showDetail(row?) {
        if (!this.depuisDemande) {
            this.editTypeContenant = !this.editTypeContenant;
            if (row) {
                this.rowSelect = row;
            }
            if (!this.editTypeContenant) {
                this.rowSelect = {};
                this.getListeBacStock();
            }   
        }
        
    }

    exportXLS() {
        const param = {
            'servlet': 'DBParametreXLS',
            'module': 'Recylog',
            'type': 'liste',
            'compression': 'false',
            'pathImpression': 'Recylog/tmp/',
            'data': [
                'stock de bennes',
                '' + this.common.user[0],
                '' + this.common.user[2],
                {
                    'typeParam': 'boolean',
                    'valeur': this.proprietes.parFournisseur
                },
                {
                    'typeParam': 'boolean',
                    'valeur': this.proprietes.parTypeDeContenant
                },
                {
                    'typeParam': 'boolean',
                    'valeur': this.proprietes.parFlux
                },
            ]
        };

        return this.common.post('', { param: param }).then(datas => {
            // $('#autocomplete').trigger('click');
            if (this.common.verifySession(datas)) {
                if (datas.data && datas.data[0]) {
                    this.common.openFile(datas.data[0]);
                } else {
                    if (datas.message) {
                        this.error = datas.message;
                        this.common.openModal(this.modalService, this.msg);
                    }
                }
            }
        });
    }

    getNbrFiltres() {
        let total = 0;

        for (const key in this.proprietes) {
            if (key) {
                if (this.proprietes[key] && this.proprietes[key] !== -1) {
                    total = total + 1;
                }
            }
        }

        const etats = this.etats.filter(etat => etat.selected);

        return total + (etats || []).length;
    }

    retourDemande() {
        this.closefct.emit();
    }
}
